export const baseImgUrl = process.env.NODE_ENV === 'development' ? 'img_url' : 'img_url'
